import { renderAudienceAge } from "./metrics/renderAudienceAge";
import { renderBio } from "./metrics/renderBio";
import { renderCredibility } from "./metrics/renderCredibility";
import { renderEr } from "./metrics/renderEr";
import { renderFemalePerAge } from "./metrics/renderFemalePerAge";
import { renderFollowers } from "./metrics/renderFollowers";
import { renderGeographicalReach } from "./metrics/renderGeographicalReach";
import { renderLanguages } from "./metrics/renderLanguages";
import { renderLocationByCity } from "./metrics/renderLocationByCity";
import { renderMalePerAge } from "./metrics/renderMalePerAge";
import { renderRecentlyPublished } from "./metrics/renderRecentlyPublished";
import { ShowcaseGridBox } from "./components/ShowcaseGridBox/ShowcaseGridBox";
import { renderCreatorInterests } from "./metrics/renderCreatorInterests";
import { renderCreatorsBrandAffinity } from "./metrics/renderCreatorsBrandAffinity";
import { renderAudienceInterests } from "./metrics/renderAudienceInterests";
import { renderAudienceBrandAffinity } from "./metrics/renderAudienceBrandAffinity";
import { renderKeywords } from "./metrics/renderKeywords";
import { renderHashtags } from "./metrics/renderHashtags";
import { renderCreatorGrowth } from "./metrics/renderCreatorGrowth";
import { SocialProvider } from "../../../../types";
import { renderAvgViews } from "./metrics/renderAvgViews";

export const renderMetrics = (
  metric,
  data,
  layout,
  recentlyPublishedReady,
  setRecentlyPublishedReady,
) => {
  const metricData = data.socialProfilesData[metric.provider];

  if (!metricData) return null;

  const GridBoxComponent = ShowcaseGridBox;

  switch (metric.type) {
    case "audience-age":
      return renderAudienceAge(
        metric.label,
        metricData,
        layout,
        GridBoxComponent,
      );

    case "audience-brand-affinity":
      return renderAudienceBrandAffinity(
        metric.label,
        metricData,
        layout,
        GridBoxComponent,
      );

    case "audience-interests":
      return renderAudienceInterests(
        metric.label,
        metricData,
        layout,
        GridBoxComponent,
      );

    case "bio":
      return renderBio(metric.label, metricData, layout, GridBoxComponent);

    case "creators-brand-affinity":
      return renderCreatorsBrandAffinity(
        metric.label,
        metricData,
        layout,
        GridBoxComponent,
      );

    case "creator-growth":
      return renderCreatorGrowth(
        metric.label,
        metricData,
        layout,
        GridBoxComponent,
      );

    case "creator-interests":
      return renderCreatorInterests(
        metric.label,
        metricData,
        layout,
        GridBoxComponent,
      );

    case "credibility":
      if (metric.provider !== SocialProvider.Instagram) return null;

      return renderCredibility(
        metric.label,
        metricData,
        layout,
        GridBoxComponent,
      );

    case "er":
      return renderEr(metric.label, metricData, layout, GridBoxComponent);

    case "female-per-age":
      return renderFemalePerAge(
        metric.label,
        metricData,
        layout,
        GridBoxComponent,
      );

    case "followers":
      return renderFollowers(
        metric.label,
        metricData,
        layout,
        GridBoxComponent,
      );

    case "geographical-reach":
      return renderGeographicalReach(
        metric.label,
        metricData,
        layout,
        GridBoxComponent,
      );

    case "hashtags":
      return renderHashtags(metric.label, metricData, layout, GridBoxComponent);

    case "keywords":
      return renderKeywords(metric.label, metricData, layout, GridBoxComponent);

    case "languages":
      return renderLanguages(
        metric.label,
        metricData,
        layout,
        GridBoxComponent,
      );

    case "location-by-city":
      if (metric.provider !== SocialProvider.Instagram) return null;

      return renderLocationByCity(
        metric.label,
        metricData,
        layout,
        GridBoxComponent,
      );

    case "male-per-age":
      return renderMalePerAge(
        metric.label,
        metricData,
        layout,
        GridBoxComponent,
      );

    case "recently-published":
      const { socialUrl } = data.socialProfiles.find(
        (item) => item.socialProvider === metric.provider,
      );

      return renderRecentlyPublished(
        metric.label,
        metricData,
        socialUrl,
        layout,
        GridBoxComponent,
        recentlyPublishedReady,
        setRecentlyPublishedReady,
      );

    case "avg-views":
      return renderAvgViews(metric.label, metricData, layout, GridBoxComponent);
  }
};
